import { render, staticRenderFns } from "./TariffsSidebar.vue?vue&type=template&id=1e412875&scoped=true&lang=pug&"
import script from "./TariffsSidebar.vue?vue&type=script&lang=js&"
export * from "./TariffsSidebar.vue?vue&type=script&lang=js&"
import style0 from "./TariffsSidebar.vue?vue&type=style&index=0&id=1e412875&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e412875",
  null
  
)

export default component.exports